import { Link } from 'react-router-dom';

export default function BlogIndex() {
  const articles = [
    {
      id: 1,
      title: 'Wall-Mounted TVs vs Entertainment Units: Pros and Cons',
      slug: 'wall-mounted-tvs-vs-entertainment-units',
      excerpt: 'Choosing between a wall-mounted TV and a traditional entertainment unit often depends on space, layout, and how the room is used day to day.',
      date: 'May 15, 2024'
    },
    {
      id: 2,
      title: 'Creating a Minimalist Setup Around a Wall-Mounted Screen',
      slug: 'minimalist-setup-wall-mounted-screen',
      excerpt: 'Minimalist interiors focus on clarity, balance, and functionality. A wall-mounted TV supports this design approach by reducing visual clutter.',
      date: 'May 12, 2024'
    },
    {
      id: 3,
      title: 'How TV Placement Affects Comfort and Viewing Experience',
      slug: 'tv-placement-comfort-viewing-experience',
      excerpt: 'TV placement has a significant impact on viewing comfort and long-term enjoyment. Screens positioned too high or at awkward angles can cause neck strain.',
      date: 'May 8, 2024'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <Link to="/" className="inline-flex items-center text-sm text-gray-600 hover:text-gray-900 mb-4 cursor-pointer">
            <i className="ri-arrow-left-line mr-2"></i>
            Back to Home
          </Link>
          <h1 className="text-4xl font-bold text-gray-900 mt-2">Wall Setup &amp; Home Installations</h1>
          <p className="text-lg text-gray-600 mt-3">Insights and guidance for modern home entertainment setups</p>
        </div>
      </header>

      {/* Articles List */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="space-y-12">
          {articles.map((article) => (
            <article key={article.id} className="border-b border-gray-200 pb-12 last:border-0">
              <time className="text-sm text-gray-500">{article.date}</time>
              <h2 className="text-2xl font-bold text-gray-900 mt-3 mb-4">
                <Link 
                  to={`/blog/${article.slug}`}
                  className="hover:text-gray-700 cursor-pointer"
                >
                  {article.title}
                </Link>
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">{article.excerpt}</p>
              <Link 
                to={`/blog/${article.slug}`}
                className="inline-flex items-center text-sm font-medium text-gray-900 hover:text-gray-700 cursor-pointer"
              >
                Read full article
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </article>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 mt-20">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-600">
            <p>&copy; 2024 Wall Setup &amp; Home Installations. All rights reserved.</p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="mt-4 md:mt-0 hover:text-gray-900 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
